import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';
import API_URL from '../api';

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  const bg = darkMode ? '#0f0f1a' : '#f0f2f5';
  const card = darkMode ? '#1a1a2e' : '#fff';
  const border = darkMode ? 'rgba(255,255,255,0.08)' : '#e0e0e0';
  const text = darkMode ? '#e0e0e0' : '#333';
  const subtext = darkMode ? '#888' : '#666';

  useEffect(() => {
    axios.get(`${API_URL}/api/auth/verify-email/${token}`)
      .then(res => {
        setStatus('success');
        setMessage(res.data.message);
        setTimeout(() => navigate('/login'), 3000);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed!');
      });
  }, [token, navigate]);

  return (
    <div style={{ minHeight: '100vh', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <style>{`@keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }`}</style>

      <div style={{ width: '100%', maxWidth: '420px', animation: 'fadeInUp 0.5s ease' }}>
        <div style={{ background: card, borderRadius: '20px', padding: '40px', border: `1px solid ${border}`, boxShadow: darkMode ? '0 20px 60px rgba(0,0,0,0.4)' : '0 20px 60px rgba(0,0,0,0.08)', textAlign: 'center' }}>

          {status === 'loading' && (
            <>
              <div style={{ width: '50px', height: '50px', border: '3px solid #e94560', borderTop: '3px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 20px' }} />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              <h2 style={{ color: text, marginBottom: '10px' }}>Verifying your email...</h2>
              <p style={{ color: subtext, fontSize: '14px' }}>Please wait a moment</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>✅</div>
              <h2 style={{ color: '#4caf50', marginBottom: '10px' }}>Email Verified!</h2>
              <p style={{ color: subtext, fontSize: '14px', marginBottom: '20px' }}>{message}</p>
              <p style={{ color: subtext, fontSize: '13px' }}>Redirecting to login in 3 seconds...</p>
              <button onClick={() => navigate('/login')} style={{ marginTop: '20px', background: 'linear-gradient(135deg, #e94560, #c62a47)', color: '#fff', padding: '12px 30px', borderRadius: '10px', fontSize: '14px', fontWeight: '600' }}>
                Go to Login
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>❌</div>
              <h2 style={{ color: '#e94560', marginBottom: '10px' }}>Verification Failed</h2>
              <p style={{ color: subtext, fontSize: '14px', marginBottom: '25px' }}>{message}</p>
              <ResendVerification darkMode={darkMode} card={card} border={border} text={text} subtext={subtext} API_URL={API_URL} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function ResendVerification({ darkMode, text, subtext, API_URL }) {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const inputBg = darkMode ? '#0f0f1a' : '#f8f8f8';
  const inputBorder = darkMode ? 'rgba(255,255,255,0.08)' : '#e0e0e0';

  const handleResend = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/auth/resend-verification`, { email });
      setMsg({ type: 'success', text: res.data.message });
    } catch (err) {
      setMsg({ type: 'error', text: err.response?.data?.error || 'Failed to resend!' });
    }
    setLoading(false);
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <p style={{ color: subtext, fontSize: '13px', marginBottom: '12px' }}>Need a new verification link?</p>
      <input
        placeholder="Enter your email"
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        style={{ background: inputBg, border: `1.5px solid ${inputBorder}`, color: text, padding: '12px', borderRadius: '10px', fontSize: '14px', width: '100%', marginBottom: '10px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
      />
      {msg && (
        <p style={{ color: msg.type === 'success' ? '#4caf50' : '#e94560', fontSize: '13px', marginBottom: '10px' }}>
          {msg.text}
        </p>
      )}
      <button onClick={handleResend} disabled={loading} style={{ background: 'linear-gradient(135deg, #e94560, #c62a47)', color: '#fff', width: '100%', padding: '12px', borderRadius: '10px', fontSize: '14px', fontWeight: '600' }}>
        {loading ? '⏳ Sending...' : '📧 Resend Verification Email'}
      </button>
    </div>
  );
}

export default VerifyEmail;